<template>
  <div class="etms-router-body">
    <el-tabs v-model="activename">
      <el-tab-pane
        label="正常运单"
        name="normalwaybill"
      >
        <div class="etms-router-search">
          <table>
            <tr>
              <td class="header-top-td">
                <el-select
                  size="mini"
                  placeholder="单号分类"
                  v-model="normalwaybill.search.OddType"
                  filterable
                  class="header-odd-category fl"
                >
                  <el-option
                    v-for="item in constant.oddtypes"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </td>
              <td rowspan="2">
                <el-input
                  size="mini"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入单号"
                  v-model="normalwaybill.search.Odd"
                  class="el-width-150 fl"
                ></el-input>
              </td>
              <td style="line-height:30px;">
                <span class="fl">归属销售：</span>
                <el-select
                  size="mini"
                  placeholder="请选择归属销售"
                  v-model="normalwaybill.search.BindSaleman"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in enterpriseaccountlist.filter(item => item.SalemanState)"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">客户：</span>
                <el-select
                  size="mini"
                  placeholder="请选择客户"
                  v-model="normalwaybill.search.CustomerId"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in customerlist.filter(item=>item.BindSaleman === normalwaybill.search.BindSaleman || normalwaybill.search.BindSaleman === '')"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">渠道：</span>
                <el-select
                  size="mini"
                  placeholder="请选择运输渠道"
                  v-model="normalwaybill.search.ChannelId"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in channellist"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">目的国家：</span>
                <el-select
                  size="mini"
                  placeholder="请选择目的国家"
                  v-model="normalwaybill.search.PurposeRegion"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in purposeregionlist"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <el-select
                  size="mini"
                  placeholder="时间分类"
                  v-model="normalwaybill.search.WaybillTimeType"
                  filterable
                  class="el-width-100 fl"
                >
                  <el-option
                    v-for="item in constant.waybilltimetypes"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <el-date-picker
                  size="mini"
                  v-model="normalwaybill.search.TimeSlot"
                  type="datetimerange"
                  align="right"
                  :picker-options="constant.pickerOptions"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="el-width-300 fl"
                >
                </el-date-picker>
                <el-button
                  size="mini"
                  type="primary"
                  icon="iconfont-mini icon-accounting"
                  class="fr"
                  @click="accountClick"
                >核算</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-search"
                  class="el-btn-margin fr"
                  @click="searchClick"
                >搜索</el-button>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="normalwaybill.pageindex"
            :page-sizes="constant.pagesizes"
            :page-size="normalwaybill.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="normalwaybill.recordcount"
          ></el-pagination>
          <el-table
            :data="normalwaybill.waybillfeelist"
            :border="true"
            height="90%"
            class="etms-router-list"
          >
            <el-table-column
              type="selection"
              width="55px"
              align="center"
            ></el-table-column>
            <el-table-column
              label="客户"
              align="center"
              prop="CustomerId"
              width="150px"
              :formatter="formatterCustomerName"
            ></el-table-column>
            <el-table-column
              label="渠道"
              align="center"
              prop="ChannelName"
              width="150px"
              :formatter="formatterChannel"
            ></el-table-column>
            <el-table-column
              label="目的国家"
              align="center"
              prop="PurposeRegion"
              width="150px"
              :formatter="formatterRegion"
            ></el-table-column>
            <el-table-column
              label="追踪单号"
              align="center"
              prop="TrackOdd"
              width="150px"
            ></el-table-column>
            <el-table-column
              label="入库时间"
              align="center"
              prop="PutStorageTime"
              width="150px"
            ></el-table-column>
            <el-table-column
              label="入库数据"
              align="center"
              prop="PutStorageTotalWeight"
              width="180px"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  content="数量"
                  placement="top"
                >
                  <span>
                    {{scope.row.PutStorageQuantity}}</span>
                </el-tooltip>
                /
                <el-tooltip
                  class="item"
                  content="重量"
                  placement="top"
                >
                  <span>
                    {{scope.row.PutStorageTotalWeight}}</span>
                </el-tooltip>
                /
                <el-tooltip
                  class="item"
                  content="体积"
                  placement="top"
                >
                  <span>
                    {{scope.row.PutStorageTotalVolume}}</span>
                </el-tooltip>
                /
                <el-tooltip
                  class="item"
                  content="体积重"
                  placement="top"
                >
                  <span>
                    {{scope.row.PutStorageTotalVolumeWeight}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="费用"
              fixed='right'
            >
              <template slot-scope="scope">
                <span
                  v-for="(item,index) in scope.row.WaybillFeeList"
                  :key="index"
                >
                  <span style="width:65px;">{{item.PriceType}}:</span>
                  <el-input
                    size="mini"
                    type="number"
                    v-model="item.Fee"
                    class="el-width-70"
                  ></el-input>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="工单处理"
        name="problemwaybill"
      >
        <div class="etms-router-search">
          <table>
            <tr>
              <td class="header-top-td">
                <el-select
                  size="mini"
                  placeholder="单号分类"
                  v-model="problemwaybill.search.OddType"
                  filterable
                  class="header-odd-category fl"
                >
                  <el-option
                    v-for="item in constant.oddtypes"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </td>
              <td rowspan="2">
                <el-input
                  size="mini"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入单号"
                  v-model="problemwaybill.search.Odd"
                  class="el-width-150 fl"
                ></el-input>
              </td>
              <td style="line-height:30px;">
                <span class="fl">归属销售：</span>
                <el-select
                  size="mini"
                  placeholder="请选择归属销售"
                  v-model="problemwaybill.search.BindSaleman"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in enterpriseaccountlist.filter(item => item.SalemanState)"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">客户：</span>
                <el-select
                  size="mini"
                  placeholder="请选择客户"
                  v-model="problemwaybill.search.CustomerId"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in customerlist.filter(item=>item.BindSaleman === problemwaybill.search.BindSaleman || problemwaybill.search.BindSaleman === '')"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">渠道：</span>
                <el-select
                  size="mini"
                  placeholder="请选择运输渠道"
                  v-model="problemwaybill.search.ChannelId"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in channellist"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <span class="fl">目的国家：</span>
                <el-select
                  size="mini"
                  placeholder="请选择目的国家"
                  v-model="problemwaybill.search.PurposeRegion"
                  filterable
                  clearable
                  class="el-width-150 fl"
                >
                  <el-option
                    v-for="item in purposeregionlist"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <el-select
                  size="mini"
                  placeholder="时间分类"
                  v-model="problemwaybill.search.WaybillTimeType"
                  filterable
                  class="el-width-100 fl"
                >
                  <el-option
                    v-for="item in constant.waybillproblemtimetypes"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
                <el-date-picker
                  size="mini"
                  v-model="problemwaybill.search.TimeSlot"
                  type="datetimerange"
                  align="right"
                  :picker-options="constant.pickerOptions"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="el-width-300 fl"
                >
                </el-date-picker>
                <el-button
                  size="mini"
                  type="primary"
                  icon="iconfont-mini icon-accounting"
                  class="fr"
                  @click="accountProblemClick"
                >核算</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-search"
                  class="el-btn-margin fr"
                  @click="searchProblemClick"
                >搜索</el-button>
              </td>
            </tr>
          </table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      enterpriseaccountlist: [
        { value: '0', label: '黄志刚', SalemanState: true, ServiceState: true, FinanceState: false },
        { value: '1', label: '焦志强', SalemanState: true, ServiceState: true, FinanceState: true },
        { value: '2', label: '肖湘南', SalemanState: true, ServiceState: true, FinanceState: true },
      ],
      customerlist: [
        { label: '广州康美森', value: '0', BindSaleman: '0' },
        { label: '广州凯捷', value: '1', BindSaleman: '1' },
      ],
      channellist: [
        { label: '广州小包', value: '0' }
      ],
      purposeregionlist: [
        { label: '美国', value: '0' },
        { label: '英国', value: '1' },
        { label: '日本', value: '2' },
      ],
      activename: 'normalwaybill',
      normalwaybill: {
        search: {
          OddType: 'serviceodd',
          Odd: '',
          BindSaleman: '',
          CustomerId: '',
          ChannelId: '',
          PurposeRegion: '',
          WaybillTimeType: 'putstoragetime',
          TimeSlot: []
        },
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        waybillfeelist: [
          {
            CustomerId: '0',
            ChannelId: '0',
            CustomerOdd: '1124524152',
            TrackOdd: 'RI455458514CN',
            PurposeRegion: '0',
            ParcelTypeId: '',
            PutStorageTime: '2018-12-10 00:12:00',
            PutStorageQuantity: 1,
            PutStorageTotalWeight: 1.121,
            PutStorageTotalVolume: 1.121,
            PutStorageTotalVolumeWeight: 1.231,
            WaybillFeeList: [
              { PriceType: '运费', Fee: 50.5 },
              { PriceType: '挂号费', Fee: 8 },
              { PriceType: '报关费', Fee: 3 },
              { PriceType: '操作费', Fee: 1 },
            ]
          }
        ],
      },
      problemwaybill: {
        search: {
          OddType: 'serviceodd',
          Odd: '',
          BindSaleman: '',
          CustomerId: '',
          ChannelId: '',
          PurposeRegion: '',
          WaybillTimeType: 'launchtime',
          TimeSlot: []
        },
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
      }
    }
  },
  methods: {
    searchClick () { },
    accountClick () { },
    handleSizeChange (val) { this.pagesize = val },
    handleCurrentChange (val) { this.pageindex = val },
    formatterCustomerName (row, column) {
      var customer = this.customerlist.filter(item => item.value === row.CustomerId)[0]
      if (customer !== undefined && customer != null) {
        return customer.label
      }
      return ''
    },
    formatterChannel (row, column) {
      var channel = this.channellist.filter(item => item.value === row.ChannelId)[0]
      if (channel !== undefined && channel != null) {
        return channel.label
      }
      return ''
    },
    formatterRegion (row, column) {
      var region = this.purposeregionlist.filter(item => item.value === row.PurposeRegion)[0]
      if (region !== undefined && region != null) {
        return region.label
      }
      return ''
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.content-outer .search-div {
  background-color: #f2f2f2;
}

.etms-router-search .header-odd-category {
  top: 1px;
  position: absolute;
}

.etms-router-search .header-top-td {
  position: relative;
  width: 120px;
}

.etms-router-search .el-btn-margin {
  margin-right: 10px;
}

.etms-router-list .el-table__expanded-cell[class*="cell"] {
  padding: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/customer_waybill_accounting.vue